import React from "react";
import Cars from '../../Assets/Reborn.png'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Button } from 'react-bootstrap';
import { SiWhatsapp } from 'react-icons/si';
import { useState } from "react";
import { Link } from "react-router-dom";
// import { ChooseCars } from '../chooseCar/choosecars'

export function ContentComp () {
  const [components, setComponents] = useState(['Samle Component'])
  function seeCarList(e){
    setComponents([...components, "Sample Component"])
      // console.log(e)
    }
    return (
    <Container fluid='xl' className="text-white" >
        <Row>
          <Col className="align-self-center" style={{zIndex : '2'}}>
          <h1>Plan Your Trip</h1>
          <h1>With Us</h1>
          <span>Sewa Mobil untuk kebutuhan mobilisasi???</span>
          <p>Vida Trans menawarkan sewa mobil dengan harga mudah, terjangkau dan bonus menarik lainnya.</p>
            <Button variant="success" size="lg" className="m-1">
                <a className="text-decoration-none d-flex align-items-center text-light" href="https://api.whatsapp.com/send?phone=+62 821-2121-5867&text=Selamat Datang!">
                <SiWhatsapp className="me-2" />Whats App
                </a>
            </Button>   
            <Button variant="outline-light" size="lg" className="m-1" onClick={e => seeCarList(e)}>
              <Link className="text-decoration-none text-light" to="/carsmenu">See Car Lists</Link>
            </Button>   
          </Col>
          <Col className="" style={{opacity : '0.3'}}>
            <img src={Cars} width='80%' alt="" />
          </Col>
        </Row>
    </Container>
    )
}